import { useState } from "react";
import { FaRobot } from "react-icons/fa";

export default function Chatbot() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  //const [reply, setReply] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [reply,setReply] = useState(
    "नमस्ते! मैं सखी हूँ। बेटी जन्मोत्सव योजना से संबंधित प्रश्न पूछ सकते हैं।"
    );
  /* FAQ Knowledge Base */

  const knowledge = [
    {
      keywords: [
        "what is beti janmotsav",
        "बेटी जन्मोत्सव क्या है",
        "scheme objective",
      ],
      question: "What is Beti Janmotsav?",
      answer:
        "बेटी जन्मोत्सव योजना का उद्देश्य बालिका के जन्म को प्रोत्साहित करना और समाज में बालिका के प्रति सकारात्मक दृष्टिकोण विकसित करना है।",
    },

    {
      keywords: ["how to apply", "आवेदन कैसे करें", "application process"],
      question: "How to apply?",
      answer:
        "इस योजना के लिए आवेदन आंगनवाड़ी केंद्र, प्राथमिक स्वास्थ्य केंद्र या सरकारी अस्पताल के माध्यम से किया जा सकता है।",
    },

    {
      keywords: ["eligibility", "who is eligible", "पात्रता"],
      question: "Who is eligible?",
      answer: "भोजपुर जिले में जन्मी बालिका इस योजना के लिए पात्र है।",
    },

    {
      keywords: ["documents", "दस्तावेज", "required documents"],
      question: "What documents are required?",
      answer:
        "आवेदन के लिए आवश्यक दस्तावेज:\n1. जन्म प्रमाण पत्र\n2. माता-पिता का आधार कार्ड\n3. स्थानीय निवास प्रमाण पत्र",
    },

    {
      keywords: ["benefits", "लाभ", "financial assistance"],
      question: "What benefits are provided?",
      answer:
        "इस योजना के अंतर्गत बालिका के जन्म पर सम्मान समारोह तथा सरकार द्वारा निर्धारित प्रोत्साहन दिया जाता है।",
    },

    {
      keywords: ["contact", "helpline", "संपर्क"],
      question: "Contact information",
      answer:
        "योजना हेल्पलाइन: 06182-XXXXXX\nमहिला एवं बाल विकास निगम, भोजपुर (आरा)",
    },
  ];

  /* Handle typing */

  const handleChange = (value) => {
    setMessage(value);

    if (value.length < 2) {
      setSuggestions([]);
      return;
    }

    const lower = value.toLowerCase();

    const matched = knowledge.filter((item) =>
      item.keywords.some((k) => k.includes(lower))
    );

    setSuggestions(matched);
  };

  /* Ask chatbot */

  const ask = (text) => {
    const q = (text || message).toLowerCase();

    let found = null;

    knowledge.forEach((item) => {
      item.keywords.forEach((k) => {
        if (q.includes(k)) {
          found = item.answer;
        }
      });
    });

    if (found) {
      setReply(found);
    } else {
      setReply(
        "माफ़ कीजिये, कृपया योजना हेल्पलाइन से संपर्क करें: 06182-XXXXXX"
      );
    }

    setSuggestions([]);
  };

  return (
    <>
      {/* Floating Icon */}

      <div
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-4 rounded-full shadow-lg cursor-pointer hover:bg-blue-700"
      >
        <FaRobot size={24} />
      </div>

      {/* Chat Window */}

      {open && (
        <div className="fixed bottom-20 right-6 w-80 bg-white shadow-xl rounded-lg border">
          {/* Header */}

          <div className="bg-blue-600 text-white p-3 flex justify-between">
            <span>🌸 सखी</span>

            <button onClick={() => setOpen(false)}>✕</button>
          </div>

          {/* Body */}

          <div className="p-4">
            <input
              value={message}
              onChange={(e) => handleChange(e.target.value)}
              placeholder="Ask your question"
              className="border p-2 w-full"
            />

            {/* Suggestions */}

            {suggestions.length > 0 && (
              <div className="border mt-1 rounded bg-gray-50">
                {suggestions.map((s, i) => (
                  <div
                    key={i}
                    onClick={() => ask(s.question)}
                    className="p-2 cursor-pointer hover:bg-gray-200 text-sm"
                  >
                    {s.question}
                  </div>
                ))}
              </div>
            )}

            <button
              onClick={() => ask()}
              className="bg-blue-600 text-white px-3 py-1 rounded mt-2"
            >
              Ask
            </button>

            {reply && (
              <p className="mt-3 text-green-700 whitespace-pre-line">{reply}</p>
            )}
          </div>
        </div>
      )}
    </>
  );
}
